import { createDom } from 'xgplayer/src/utils/util';
import Loading from '../assets/play.svg';
import '../style/controls/enter.scss';

let s_enter = function() {
  let player = this;
  let root = player.root;
  let container = createDom(
    'xg-enter',
    `
  <div class="xg-enter-icon">
    ${Loading}${Loading}${Loading}
  </div>
  <div class="xg-enter-text">正在加载...</div>
  `,
    {},
    'xgplayer-enter'
  );
  player.once('ready', () => {
    root.appendChild(container);
  });
};

export default {
  name: 's_enter',
  method: s_enter
};
